import { render, staticRenderFns } from "./InlineVideo.vue?vue&type=template&id=ceabb904"
import script from "./InlineVideo.vue?vue&type=script&lang=js"
export * from "./InlineVideo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports